import { Component, OnInit } from '@angular/core';
import { tabs } from 'src/app/dummy/tabs';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { AddTermComponent } from '../add-term/add-term.component';
import { TERM_TYPES_OBJECT } from 'src/app/dummy/status';
import { AuthService } from 'src/app/auth/auth.service';
import { Term } from 'src/app/stores/administrator/term.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-term',
  templateUrl: './term.component.html',
  styleUrls: ['./term.component.scss']
})
export class TermComponent implements OnInit {
  tabs = tabs.TERMS
  TYPE: any;
  constructor(
    private auth: AuthStore,
    private route: ActivatedRoute,
    public store: Term,
    private ds: DataService,
    public dialog: MatDialog) { }

  create(event) {
    const dialogRef = this.dialog.open(AddTermComponent, {
      data: this.TYPE,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  async ngOnInit() {
    await this.auth.fetchEnvironment();

    this.route.params.subscribe(params => {
      const { id } = params;
      this.TYPE = TERM_TYPES_OBJECT[id];
      this.store.fetchData(this.ds.termRef(ref => ref.where('termType.key', "==", id)))
    })

  }

  ngOnDestroy() {
    this.store.dispost();
  }



}
